import type { FollowButtonAction, FollowType } from "@product/scmp-sdk";

interface UserFollowEntity {
  entityId: string;
  entityUuid: string;
  name: string;
  urlAlias: string;
}

export type UserFollowList = {
  authors: UserFollowEntity["entityId"][];
  sections: UserFollowEntity["entityId"][];
  topics: UserFollowEntity["entityId"][];
};

export interface GetUserFollowList {
  userFollowList: UserFollowList;
}

export interface GetUserFollowListDetails {
  detailUserFollowList: {
    authors: UserFollowEntity[];
    sections: UserFollowEntity[];
    topics: UserFollowEntity[];
  };
}

export type FollowPayload = {
  action: FollowButtonAction;
  ids: string[];
  type: FollowType;
  uuid: string;
};

export type FollowPayloadMessageItem = Omit<FollowPayload, "type"> & {
  type: "sections_topics_authors";
};

export type FollowListKeys = keyof GetUserFollowList["userFollowList"];

export interface FollowQueryStringPayload {
  action?: {
    follow?: {
      [key: string]: string | string[];
    };
    follow_config?: {
      [FollowType.Author]: string | string[];
      [FollowType.Section]: string | string[];
      [FollowType.Topic]: string | string[];
    };
  };
  source?: FollowButtonSource;
  utm_source?: string;
}
export const followButtonSources = [
  "Article_topic_footer",
  "Homepage_gba",
  "HP Topics",
  "Top Story 1",
  "HP Section Block",
  "Trending Topics",
  "Homepage_feature_package",
  "Article_top",
  "Article_bottom",
  "Topic",
  "Author",
  "Trending_topics",
  "Homepage_click",
  "Section",
] as const;
export type FollowButtonSource = (typeof followButtonSources)[number];
export type FollowButtonTriggerPoint = FollowButtonSource | "homepage_click";
